var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.852 12.004L.23 22.7a.764.764 0 000 1.076.75.75 0 001.068 0L12 13l10.703 10.778a.75.75 0 001.069 0 .764.764 0 000-1.076L13.148 12.004l10.63-10.706a.764.764 0 000-1.075.752.752 0 00-1.067 0L12 11.008 1.289.223a.752.752 0 00-1.068 0 .764.764 0 000 1.076l10.631 10.705z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

export default SvgCloseBig;